import { render } from 'utils/jsx'
import PWA from 'controllers/PWA'
import lastOf from 'utils/array-last-of'

///////////////////
////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
//////////

;(async () => {
  PWA.register()
  render((
    <main>
      <button
        class='install'
        event-click={PWA.prompt}
      >
        {/* TODO: use internal state instead of body classes */}
        <span class='install__support'>installer l’application</span>
        <span class='install__no-support'>PWA non supportée</span>
        <span class='install__has-installed'>PWA déjà installée</span>
        <span class='install__standalone'>PWA lancée</span>
        <span class='install_is-ios'>Sur iPhone, click sur « ajouter à l’écran d’accueil »</span>
      </button>
    </main>
  ), document.body)
  document.body.classList.remove('is-loading')
})()

// Get a canvas defined with ID 'oscilloscope'
const canvas = document.createElement('canvas')
canvas.width = window.innerWidth
canvas.height = window.innerHeight
document.body.append(canvas)
const canvasCtx = canvas.getContext('2d')

const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)()
recognition.continuous = true
recognition.lang = 'fr-FR'
recognition.interimResults = true
recognition.maxAlternatives = 1

document.body.onclick = function () {
  let source
  recognition.start()
  const audioCtx = new (window.AudioContext || window.webkitAudioContext)()
  const analyser = audioCtx.createAnalyser()
  analyser.fftSize = 2048
  const bufferLength = analyser.frequencyBinCount
  const dataArray = new Uint8Array(bufferLength)
  analyser.getByteTimeDomainData(dataArray)

  // main block for doing the audio recording
  if (navigator.mediaDevices.getUserMedia) {
    console.log('getUserMedia supported.')
    var constraints = { audio: true }
    navigator.mediaDevices.getUserMedia(constraints)
      .then(
        function (stream) {
          source = audioCtx.createMediaStreamSource(stream)
          // Connect the source to be analysed
          source.connect(analyser)
        })
      .catch(function(err) {
        console.log('The following gUM error occured: ' + err)
      })
   } else {
    console.log('getUserMedia not supported on your browser!')
  }

  // draw an oscilloscope of the current audio source

  function draw () {
    window.requestAnimationFrame(draw)

    analyser.getByteTimeDomainData(dataArray)

    canvasCtx.clearRect(0, 0, canvas.width, canvas.height)
    canvasCtx.lineWidth = 2
    canvasCtx.lineJoin = 'round'
    canvasCtx.strokeStyle = 'rgb(0, 0, 0)'
    canvasCtx.beginPath()

    const sliceWidth = canvas.width * 1.0 / bufferLength
    let x = 0

    for (let i = 0; i < bufferLength; i++) {
      const v = dataArray[i] / 128.0
      const y = v * canvas.height / 2

      if (i === 0) canvasCtx.moveTo(x, y)
      else canvasCtx.lineTo(x, y)
      x += sliceWidth
    }

    canvasCtx.lineTo(canvas.width, canvas.height / 2)
    canvasCtx.stroke()
  }

  draw()
  console.log('Listenning to speech')
}

const h1 = document.createElement('h1')
document.body.append(h1)

recognition.onresult = function (event) {
  const result = lastOf(Array.from(event.results))[0]
  h1.innerText = result.transcript
  h1.style.setProperty('--confidence', result.confidence)
}
